export default __webpack_public_path__ + "static/media/buen_dia.c84f8fec.png";